'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isTransitionEndSupported = {};

exports.__exports = isTransitionEndSupported;
